<template>
  <div class="in-orders p-4 bg-white box-shaddow20 overflow-auto border-r-10">
    <div class="d-flex align-items-center justify-content-between pb-4">
      <div class="d-flex align-items-center gap-5 custom-border-right px-2">
        <OrderIcon />
        <h4 class="font-w-400 font-s-18 text-color-theme-dark m-0">
          لیست سفارشات
        </h4>
      </div>
    </div>
    <div :class="{ skeleton: !orders && status }" class="pb-3 flex-wrap border-bottom">
      <template v-if="!mediaQueries.mobileSize">
        <b-skeleton v-if="!orders && status" type="button"></b-skeleton>
        <button
          v-else
          @click="showOrders(1, 'all')"
          class="statusBtn px-4 mr-3 bg-none font-w-400 font-s-15 text-color-theme-dark"
          :class="{ 'order-tracking-active': orderTrackingTab === 1 }"
        >
          همه
        </button>

        <b-skeleton v-if="!orders && status" type="button"></b-skeleton>
        <button
          v-else
          @click="showOrders(2, 'New')"
          class="statusBtn px-4 mr-3 bg-none font-w-400 font-s-15 text-color-theme-dark"
          :class="{ 'order-tracking-active': orderTrackingTab === 2 }"
        >
          جدید
          <span
            v-if="statistics != null && statistics.new != 0"
            class="statistics rounded-circle bg-color-themeRed text-white p-1 fontsize12 weight-bold"
          >
            {{ statistics.new }}</span
          >
        </button>

        <!-- <b-skeleton v-if="!orders && status " type="button"></b-skeleton>
        <button
            v-else @click="showOrders(2, 'canceled_by_user')"
            class=" statusBtn text-color-666 px-4 mr-3 border bg-none   fontsize14"
            :class="{ 'order-tracking-active': orderTrackingTab === 2 }">
          حذف توسط کاربر
          <span
              v-if="statistics != null && statistics.new != 0"
              class="statistics rounded-circle bg-color-themeRed text-white p-1 fontsize12 weight-bold">
              {{ statistics.new }}</span>
        </button> -->

        <b-skeleton v-if="!orders && status" type="button"></b-skeleton>
        <button
          v-else
          @click="showOrders(3, 'DELIVERED')"
          class="statusBtn px-4 mr-3 bg-none font-w-400 font-s-15 text-color-theme-dark"
          :class="{ 'order-tracking-active': orderTrackingTab === 3 }"
        >
          تکمیل شده
          <span
            v-if="statistics != null && statistics.delivered != 0"
            class="statistics rounded-circle bg-color-themeRed text-white p-1 fontsize12 weight-bold"
          >
            {{ statistics.delivered }}</span
          >
        </button>
        <b-skeleton v-if="!orders && status" type="button"></b-skeleton>
        <button
          v-else
          @click="showOrders(4, 'IN_PROGRESS')"
          class="statusBtn px-4 mr-3 bg-none font-w-400 font-s-15 text-color-theme-dark"
          :class="{ 'order-tracking-active': orderTrackingTab === 4 }"
        >
          دردست اقدام
          <span
            v-if="statistics != null && statistics.in_progress != 0"
            class="statistics rounded-circle bg-color-themeRed text-white p-1 fontsize12 weight-bold"
          >
            {{ statistics.in_progress }}</span
          >
        </button>
        <b-skeleton v-if="!orders && status" type="button"></b-skeleton>
        <button
          v-else
          @click="showOrders(5, 'RESERVED')"
          class="statusBtn px-4 mr-3 bg-none font-w-400 font-s-15 text-color-theme-dark"
          :class="{ 'order-tracking-active': orderTrackingTab === 5 }"
        >
          رزرو شده
          <span
            v-if="statistics != null && statistics.reserved != 0"
            class="statistics rounded-circle bg-color-themeRed text-white p-1 fontsize12 weight-bold"
          >
            {{ statistics.reserved }}</span
          >
        </button>
        <b-skeleton v-if="!orders && status" type="button"></b-skeleton>
        <button
          v-else
          @click="showOrders(6, 'WAIT_FOR_PAYMENT')"
          class="statusBtn px-4 mr-3 bg-none font-w-400 font-s-15 text-color-theme-dark"
          :class="{ 'order-tracking-active': orderTrackingTab === 6 }"
        >
          در انتظار پرداخت
          <span
            v-if="statistics != null && statistics.wait_for_payment != 0"
            class="statistics rounded-circle bg-color-themeRed text-white p-1 fontsize12 weight-bold"
          >
            {{ statistics.wait_for_payment }}</span
          >
        </button>
        <b-skeleton v-if="!orders && status" type="button"></b-skeleton>
        <button
          v-else
          @click="showOrders(7, 'CANCELED')"
          class="statusBtn px-4 mr-3 bg-none font-w-400 font-s-15 text-color-theme-dark"
          :class="{ 'order-tracking-active': orderTrackingTab === 7 }"
        >
          لغو شده
          <span
            v-if="statistics != null && statistics.canceled != 0"
            class="statistics rounded-circle bg-color-themeRed text-white p-1 fontsize12 weight-bold"
          >
            {{ statistics.canceled }}</span
          >
        </button>
      </template>
      <template v-else>
        <treeselect
          :clearable="false"
          :options="orderOptions"
          v-model="selectedOrder"
        />
      </template>
    </div>
    <section id="orderSection" v-if="tab === 3">
      <template v-if="status">
        <hr />
        <div class="skeleton">
          <b-skeleton v-if="status" type="button"></b-skeleton>

          <b-skeleton v-if="status" type="button"></b-skeleton>

          <b-skeleton v-if="status" type="button"></b-skeleton>

          <b-skeleton v-if="status" type="button"></b-skeleton>

          <b-skeleton v-if="status" type="button"></b-skeleton>

          <b-skeleton v-if="status" type="button"></b-skeleton>
        </div>
        <hr />
        <b-skeleton></b-skeleton>
        <hr />
        <b-skeleton></b-skeleton>
        <hr />
        <b-skeleton></b-skeleton>
        <hr />
        <b-skeleton></b-skeleton>
      </template>
      <template v-else>
        <div id="tabelBox">
          <!-- همه سفارشات -->
          <table
            v-if="orderTrackingTab === 1"
            class="table table-responsive"
            style="display: table"
          >
            <template v-if="orders.data.length != 0">
              <thead>
                <tr class="text-color-444 fontsize14">
                  <th scope="col">شناسه</th>
                  <th scope="col">هزینه ارسال</th>
                  <th scope="col">تخفیف</th>
                  <th scope="col">وضعیت</th>
                  <th scope="col">قیمت</th>
                  <th scope="col">تاریخ سفارش</th>
                  <th scope="col">جزئیات</th>
                </tr>
              </thead>
              <tbody v-if="orders != null">
                <template v-for="order in orders.data" class="trHover">
                  <tr v-if="order.parent_id == null" :key="order.id">
                    <td>{{ order.id }}</td>
                    <td>
                      <template v-if="order.shipping_amount == null"
                        >رایگان</template
                      >
                      <template v-else>{{
                        getCalcSumOf(order, "shipping_amount") | price
                      }}</template>
                    </td>

                    <td>
                      <template
                        v-if="getCalcSumOf(order, 'discount_amount') == 0"
                        >بدون تخفیف</template
                      >
                      <template v-else>{{
                        getCalcSumOf(order, "discount_amount") | price
                      }}</template>
                    </td>
                    <td>
                      <OrderStatus :status="order.status" />
                    </td>
                    <td>
                      <template v-if="findPriceOrder(order) == 0"
                        >------</template
                      >
                      <template v-else>{{
                        findPriceOrder(order) | price
                      }}</template>
                    </td>
                    <td style="word-spacing: 6px">
                      {{ moment(order.created_at).format("HH:mm YYYY/MM/DD") }}
                    </td>
                    <td>
                      <router-link
                        :to="{ name: 'order', params: { id: order.id } }"
                      >
                        <button
                          class="showDetailBtn py-2 text-color-666 px-4 mr-3 border bg-none fontsize14"
                        >
                          جزئیات <span class="go-to-icon"><ZNextSvg /></span>
                        </button>
                      </router-link>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
            <div class="notContent" v-else>
              <svg
                width="66"
                height="65"
                viewBox="0 0 66 65"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M41.1248 61.6149H24.8748C10.1686 61.6149 3.88525 55.3316 3.88525 40.6253V24.3753C3.88525 9.66908 10.1686 3.38574 24.8748 3.38574H38.4165C39.5269 3.38574 40.4478 4.30658 40.4478 5.41699C40.4478 6.52741 39.5269 7.44824 38.4165 7.44824H24.8748C12.3894 7.44824 7.94775 11.8899 7.94775 24.3753V40.6253C7.94775 53.1107 12.3894 57.5524 24.8748 57.5524H41.1248C53.6103 57.5524 58.0519 53.1107 58.0519 40.6253V27.0837C58.0519 25.9732 58.9728 25.0524 60.0832 25.0524C61.1936 25.0524 62.1144 25.9732 62.1144 27.0837V40.6253C62.1144 55.3316 55.8311 61.6149 41.1248 61.6149Z"
                  fill="#C4C1C1"
                />
                <path
                  d="M60.0832 29.1148H49.2498C39.9873 29.1148 36.3853 25.5127 36.3853 16.2502V5.4169C36.3853 4.6044 36.8728 3.84607 37.6311 3.54815C38.3894 3.22315 39.2561 3.41273 39.8519 3.98148L61.5186 25.6481C62.0873 26.2169 62.2769 27.1106 61.9519 27.869C61.6269 28.6273 60.8957 29.1148 60.0832 29.1148ZM40.4478 10.319V16.2502C40.4478 23.2377 42.2623 25.0523 49.2498 25.0523H55.1811L40.4478 10.319Z"
                  fill="#C4C1C1"
                />
                <path
                  d="M35.7085 37.2393H19.4585C18.3481 37.2393 17.4272 36.3184 17.4272 35.208C17.4272 34.0976 18.3481 33.1768 19.4585 33.1768H35.7085C36.8189 33.1768 37.7397 34.0976 37.7397 35.208C37.7397 36.3184 36.8189 37.2393 35.7085 37.2393Z"
                  fill="#C4C1C1"
                />
                <path
                  d="M30.2918 48.0732H19.4585C18.3481 48.0732 17.4272 47.1524 17.4272 46.042C17.4272 44.9316 18.3481 44.0107 19.4585 44.0107H30.2918C31.4022 44.0107 32.3231 44.9316 32.3231 46.042C32.3231 47.1524 31.4022 48.0732 30.2918 48.0732Z"
                  fill="#C4C1C1"
                />
              </svg>

              <h5 class="font-w-500 font-s-18 text-color-theme-grey2 mt-3">
                سفارشی برای پیگیری وجود ندارد
              </h5>
            </div>
          </table>
          <table
            v-if="orderTrackingTab != 1 && orders != null"
            class="table table-responsive"
            style="display: table"
          >
            <template v-if="orders.data.length != 0">
              <thead>
                <tr class="text-color-444 fontsize14">
                  <th scope="col">شناسه</th>
                  <th scope="col">مبلغ</th>
                  <th scope="col">تخفیف</th>
                  <th scope="col">وضعیت</th>
                  <th scope="col">تاریخ سفارش</th>
                  <th scope="col">جزئیات</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(order, index) in orders.data"
                  class="trHover"
                  :key="order.id"
                >
                  <th scope="row">
                    {{ order.id }}
                  </th>
                  <td>
                    <template v-if="findPriceOrder(order) == 0"
                      >------</template
                    >
                    <template v-else>{{
                      findPriceOrder(order) | price
                    }}</template>
                  </td>
                  <td>
                    {{
                      order.discount_amount == 0
                        ? "بدون تخفیف"
                        : order.discount_amount
                    }}
                  </td>
                  <td>
                    <OrderStatus :status="order.status" />
                  </td>
                  <td style="word-spacing: 6px" scope="row">
                    {{ moment(order.created_at).format("HH:mm YYYY/MM/DD") }}
                  </td>
                  <td>
                    <router-link
                      :to="{ name: 'order', params: { id: order.id } }"
                    >
                      <button
                        class="showDetailBtn py-2 text-color-666 px-4 mr-3 border bg-none fontsize14"
                      >
                        جزئیات
                      </button>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </template>
            <div class="notContent" v-else>
              <svg
                width="66"
                height="65"
                viewBox="0 0 66 65"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M41.1248 61.6149H24.8748C10.1686 61.6149 3.88525 55.3316 3.88525 40.6253V24.3753C3.88525 9.66908 10.1686 3.38574 24.8748 3.38574H38.4165C39.5269 3.38574 40.4478 4.30658 40.4478 5.41699C40.4478 6.52741 39.5269 7.44824 38.4165 7.44824H24.8748C12.3894 7.44824 7.94775 11.8899 7.94775 24.3753V40.6253C7.94775 53.1107 12.3894 57.5524 24.8748 57.5524H41.1248C53.6103 57.5524 58.0519 53.1107 58.0519 40.6253V27.0837C58.0519 25.9732 58.9728 25.0524 60.0832 25.0524C61.1936 25.0524 62.1144 25.9732 62.1144 27.0837V40.6253C62.1144 55.3316 55.8311 61.6149 41.1248 61.6149Z"
                  fill="#C4C1C1"
                />
                <path
                  d="M60.0832 29.1148H49.2498C39.9873 29.1148 36.3853 25.5127 36.3853 16.2502V5.4169C36.3853 4.6044 36.8728 3.84607 37.6311 3.54815C38.3894 3.22315 39.2561 3.41273 39.8519 3.98148L61.5186 25.6481C62.0873 26.2169 62.2769 27.1106 61.9519 27.869C61.6269 28.6273 60.8957 29.1148 60.0832 29.1148ZM40.4478 10.319V16.2502C40.4478 23.2377 42.2623 25.0523 49.2498 25.0523H55.1811L40.4478 10.319Z"
                  fill="#C4C1C1"
                />
                <path
                  d="M35.7085 37.2393H19.4585C18.3481 37.2393 17.4272 36.3184 17.4272 35.208C17.4272 34.0976 18.3481 33.1768 19.4585 33.1768H35.7085C36.8189 33.1768 37.7397 34.0976 37.7397 35.208C37.7397 36.3184 36.8189 37.2393 35.7085 37.2393Z"
                  fill="#C4C1C1"
                />
                <path
                  d="M30.2918 48.0732H19.4585C18.3481 48.0732 17.4272 47.1524 17.4272 46.042C17.4272 44.9316 18.3481 44.0107 19.4585 44.0107H30.2918C31.4022 44.0107 32.3231 44.9316 32.3231 46.042C32.3231 47.1524 31.4022 48.0732 30.2918 48.0732Z"
                  fill="#C4C1C1"
                />
              </svg>

              <h5 class="font-w-500 font-s-18 text-color-theme-grey2 mt-3">
                سفارشی برای پیگیری وجود ندارد
              </h5>
            </div>
          </table>
        </div>

        <section
          id="mainPaginationBlog"
          v-if="orders && orders.last_page > 1"
          class="orders-list-pagination text-center mb-4 mt-0 p-2 bg-color-fa"
        >
          <section
            id="listPagination"
            class="list-pagination orders-list-pagination text-center py-2"
          >
            <pagination
              :limit="1"
              :data="orders"
              @pagination-change-page="changePage"
              :disabled="status"
              class="justify-content-center"
            >
              <span slot="prev-nav">
                <ZPrevSvg />
              </span>
              <span slot="next-nav">
                <ZNextSvg />
              </span>
            </pagination>
          </section>
        </section>
      </template>
    </section>
  </div>
</template>
<script>
import {
  findPayments,
  getInvoicesStatus,
  getSumPrice,
} from "@/libraries/functions";
import { Treeselect } from "@riophae/vue-treeselect";
import paginationMixin from "@/libraries/mixins/paginationMixin";
import LineGrow from "@/parts/Front/components/shared/LineGrow";
import OrderStatus from "@/parts/Front/components/panel/OrderStatus";
import ZPrevSvg from "@/parts/Front/components/shared/ZPrevSvg";
import ZNextSvg from "@/parts/Front/components/shared/ZNextSvg";
import OrderIcon from "@/parts/Front/components/Icon/panelIcons/Order.vue";
export default {
  inject: ["mediaQueries"],
  mixins: [paginationMixin],
  props: { tab: { Number } },
  data() {
    return {
      orderTrackingTab: 1,
      selectedOrder: "all",
      orderOptions: [
        {
          id: "all",
          label: "همه",
        },
        {
          id: "New",
          label: "جدید",
        },
        {
          id: "DELIVERED",
          label: "تکمیل شده",
        },
        {
          id: "IN_PROGRESS",
          label: "در دست اقدام",
        },
        {
          id: "RESERVED",
          label: "رزور شده",
        },
        {
          id: "WAIT_FOR_PAYMENT",
          label: "در انتظار پرداخت",
        },
        {
          id: "CANCELED",
          label: "لغو شده",
        },
      ],
    };
  },
  computed: {
    statistics() {
      return this.$store.getters["front/getOrderStatistics"];
    },
    // دریافت استاتوس وضعیت گرفتن سفارشات از سرور
    status() {
      return this.$store.getters["front/getOrdersInPanelStatus"];
    },
    // دریافت سفارشات از سرور
    orders() {
      return this.$store.getters["front/getOrdersInPanel"];
    },
  },
  created() {
    // اگر لیست سفارشات خالی بود از سرور گرفته شود
    if (this.orders == null) {
      let pack = {};
      if (this.$route.query.page) {
        pack.page = this.$route.query.page;
      } else {
        pack.page = 1;
      }
      if (this.$route.query.status != undefined) {
        pack.status = this.$route.query.status;
      } else {
        pack.status = "all";
      }
      this.$store.dispatch("front/getOrderInPanelFromServer", pack);
    }
  },
  watch: {
    selectedOrder(newVal) {
      if (newVal == "all") {
        this.orderTrackingTab = 1;
      }
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, status: newVal },
      });
    },
    // در صورت تغییر کوئری صقحه با چجینیشن درخواست جدید داده شود
    "$route.query.status": {
      handler: function (val) {
        const data = {
          status: val != undefined ? val : "all",
        };
        data.page =
          this.$route.query.page != undefined ? this.$route.query.pagee : "1";
        this.$store.dispatch("front/getOrderInPanelFromServer", data);
      },
    },
    "$route.query.page": {
      handler: function (val) {
        const data = {
          page: val != undefined ? val : "1",
        };

        data.status =
          this.$route.query.status != undefined
            ? this.$route.query.status
            : "all";

        this.$store.dispatch("front/getOrderInPanelFromServer", data);
      },
    },
  },
  methods: {
    findPayments,
    getInvoicesStatus,
    getSumPrice,
    getCalcSumOf(order, key) {
      let sum = 0;
      sum += order[key];
      order.childs.forEach((child) => {
        sum += child[key];
      });
      return sum;
    },
    findPriceOrder(order) {
      let sum = 0;
      sum += this.getTotalOrder(order);
      order.childs.forEach((child) => {
        sum += this.getTotalOrder(child);
      });
      return sum;
    },
    checkTrueStatus(status) {
      let success = ["in_progress", "delivered", "new"];
      return success.includes(status);
    },
    getTotalOrder(order) {
      let orderItems = order.items.filter((item) => {
        if (
          item.status == 1 &&
          item.order_id == order.id &&
          this.checkTrueStatus(order.status)
        ) {
          return item;
        }
      });
      if (orderItems != "") {
        let sum = 0;
        orderItems.forEach((item) => {
          sum = sum + item.amount * item.quantity;
        }, 0);
        return sum;
      } else {
        return 0;
      }
    },
    // findPriceOrder(order) {
    //   let amount = 0;
    //   order.invoices.forEach((invoice) => {
    //     amount += invoice.amount;
    //   });
    //   order.childs.forEach((child) => {
    //     child.invoices.forEach((invoice) => {
    //       amount += invoice.amount;
    //     });
    //   });
    //   // return amount+this.getCalcSumOf(order, "shipping_amount")-this.getCalcSumOf(order, "discount_amount");
    //   return amount
    // },
    changePage(page) {
      this.$nextTick(() => {
        document
          .querySelector(".in-user-panel")
          .scrollIntoView({ behavior: "smooth" });
      });
      if (this.disabled) {
        return;
      }
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, page: page },
      });
    },

    // با کلیک بروی دکمه ها خروجی سفارشات آن دسته نمایش داده میشود
    showOrders(orderTrackingTab, status) {
      this.orderTrackingTab = orderTrackingTab;
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, status: status },
      });
    },
  },
  mounted() {
    // بررسی کوئری برای نمایش دکمه مورد نظر در اولین برخورد
    let status = this.$route.query.status;
    if (this.$route.query.status != undefined) {
      if (status.toLowerCase() == "all") {
        this.orderTrackingTab = 1;
        this.selectedOrder = "all";
      } else {
        switch (status.toLowerCase()) {
          case "new":
            this.orderTrackingTab = 2;
            this.selectedOrder = "New";
            break;

          case "delivered":
            this.selectedOrder = "DELIVERED";
            this.orderTrackingTab = 3;
            break;

          case "in_progress":
            this.selectedOrder = "IN_PROGRESS";
            this.orderTrackingTab = 4;
            break;
          case "reserved":
            this.selectedOrder = "RESERVED";
            this.orderTrackingTab = 5;
            break;

          case "wait_for_payment":
            this.selectedOrder = "WAIT_FOR_PAYMENT";
            this.orderTrackingTab = 6;
            break;

          case "canceled":
            this.selectedOrder = "CANCELED";
            this.orderTrackingTab = 7;
            break;
        }
      }
    }
  },
  components: {
    ZNextSvg,
    ZPrevSvg,
    LineGrow,
    OrderStatus,
    Treeselect,
    OrderIcon,
  },
};
</script>
<style scoped>
/* افزودن استایل به کدهای اضافه شده به قالب */
.skeleton {
  display: flex;
  justify-content: space-around;
}
@media screen and (max-width: 570px) {
  .skeleton {
    gap: 7px;
  }
}
.trHover:hover .showDetailBtn {
  background-color: #e8e8e8 !important;
}
.go-to-icon {
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translate(20px, -56%);
  opacity: 0;
  transition: 250ms all;
}
.showDetailBtn:hover .go-to-icon {
  opacity: 1;
  transform: translate(0px, -56%);
}

.showDetailBtn {
  position: relative;
  background-color: rgba(239, 239, 239, 0.9) !important;
  transition: 200ms all;
}
.showDetailBtn:hover {
  box-shadow: 0 0 10px -5px white;
}
.trHover {
  transition: all 0.5s;
  box-shadow: inset 0 0 19px -21px;
}
.trHover:hover {
  box-shadow: inset 0 0 19px -16px;
  /*background: #fcfcfc;*/
  background: #ffffff;
}
.notContent {
  margin-top: 4%;
  text-align: center;
}
.statusBtn {
  height: 37px;
  margin-top: 5px;
  transition: all 0.5s;
}
.statusBtn:hover {
  background-color: var(--color-theme5) !important;
  color: white !important;
  border-radius: 27px;
}
#statusBtns {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  position: relative;
}
#tabelBox,
#orderSection {
  width: 100%;
  overflow: auto;
}
.statistics {
  position: relative;
  background-color: var(--color-theme3);
  right: 24px;
  min-width: 26px;
  height: 100%;
  line-height: 31px;
  display: inline-block;
  border-radius: 0 !important;
  font-size: 14px;
}
@media screen and (max-width: 570px) {
  .in-orders >>> .b-skeleton-button {
    width: 60px;
  }
}
@media screen and (max-width: 420px) {
  .in-orders >>> .b-skeleton-button {
    width: 40px;
  }
}

.in-orders >>> .pagination {
  margin-bottom: 0;
}

.orders-list-pagination {
  border-radius: 10px;
}

.order-tracking-active {
  background-color: var(--color-theme6) !important;
  color: white !important;
  border: unset !important;
  border-radius: 27px !important;
}
</style>
